import { render } from "./BoxesCustomerDashboard.vue?vue&type=template&id=5fbdbed2&scoped=true"
import script from "./BoxesCustomerDashboard.vue?vue&type=script&lang=js"
export * from "./BoxesCustomerDashboard.vue?vue&type=script&lang=js"

import "./BoxesCustomerDashboard.vue?vue&type=style&index=0&id=5fbdbed2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbdbed2"]])

export default __exports__